class ProductDetailPayWithCredits extends Component {
    constructor(el) {
        super(el);
        this.addEventListeners();
    }

    /**
     * @param {Number} creditPrice
     * @return void
     */
    updatePayWithCreditVisibility(creditPrice) {
        if (creditPrice > 0) {
            this.$el.classList.remove("u-hidden");
        } else {
            this.$el.classList.add("u-hidden");
        }
    }

    onVariantChange(variant) {
        const creditPrice = Number.parseInt(variant.creditPrice);
        this.updatePayWithCreditVisibility(creditPrice);
    }

    addEventListeners() {
        EventBus.getInstance().addEventListener('productVariantChanged', e => this.onVariantChange(e.detail));
    }
}